export enum ProposalStatusEnum {
  'Rascunho' = 1,
  'Enviada' = 2,
  'Em andamento' = 3,
  'Aceita' = 4,
  'Recusada' = 5,
  'Iniciada' = 6,
  'Finalizada' = 7,
}
